import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import BiotechIcon from "@mui/icons-material/Biotech";
import GroupsIcon from "@mui/icons-material/Groups";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DirectionsBoatFilledIcon from "@mui/icons-material/DirectionsBoatFilled";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

const objectList = [
  {
    icon: (
      <CurrencyExchangeIcon
        fontSize="large"
        sx={{
          color: "#00AEEF",
          width: 92,
          height: 92,
        }}
      />
    ),
    title: "BuyBack Initiative",
    subtitle:
      "Fish Shoal Nigeria; the commercial farm of Aquatic Hub Afrique is solely responsible for product aggregation along the value chain of aquaculture. Fish Shoal Nigeria ensures a buyback strategy in scenarios where farmers cannot sell profitably; this is termed a win-win model.",
  },
  {
    icon: (
      <BiotechIcon
        fontSize="large"
        sx={{
          color: "#00AEEF",
          width: 92,
          height: 92,
        }}
      />
    ),
    title: "Laboratory Services",
    subtitle:
      "Located in Abeokuta, 80km from Lagos, which is Nigeria’s commercial capital. Aquatic Hub offers laboratory services for farmers willing to carry out water test and other tests needed on their farms.",
  },
  {
    icon: (
      <AccountBalanceIcon
        fontSize="large"
        sx={{
          color: "#00AEEF",
          width: 92,
          height: 92,
        }}
      />
    ),
    title: "Micro-Seed Funding",
    subtitle:
      "Our graduates are exposed to several opportunities available to access loans and soft credits and also grants available. Everyone under our network is exposed to this in a bid to ensure that they upscale their businesses.",
  },
  {
    icon: (
      <GroupsIcon
        fontSize="large"
        sx={{
          color: "#00AEEF",
          width: 92,
          height: 92,
        }}
      />
    ),
    title: "Aquatic Hub Cooperatives",
    subtitle:
      "Upon successful completion of the programme, our graduates are grouped into clusters along with other small holder farmers to enjoy benefits of a cooperative society.",
  },
  {
    icon: (
      <VisibilityIcon
        fontSize="large"
        sx={{
          color: "#00AEEF",
          width: 92,
          height: 92,
        }}
      />
    ),
    title: "Monitoring and Quality Evaluation",
    subtitle:
      "Aquatic Hub monitors established projects as well as the methodologies involved for a robust and meaningful endpoint and result.",
  },
  {
    icon: (
      <DirectionsBoatFilledIcon
        fontSize="large"
        sx={{
          color: "#00AEEF",
          width: 92,
          height: 92,
        }}
      />
    ),
    title: "Transportation and Logistics",
    subtitle:
      "Aquatic Hub delivers all orders made across Africa. We have the capacity to get your orders to your doorstep within the delivery terms stated while placing your orders; we also ensure that these orders are delivered in good conditions.",
  },
];

const Framework = () => {
  return (
    <Box
      margin={{ xs: "20% 0%", sm: "5% 0% 5% 0%" }}
      padding={{ xs: "20% 0%", sm: "0%" }}
    >
      <Typography
        variant={"body1"}
        fontWeight={700}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"1%"}
      >
        Our mission is to produce high-quality, affordable fish stocks and
        ensure that no African is deprived of access to fish protein.
      </Typography>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Thematic Framework
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid item xs={12} sm={6} md={4}>
                <Box
                  key={index}
                  height={"100%"}
                  padding={{ xs: "4% 0%", sm: "4% 4%" }}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  width={{ xs: "100%", sm: "100%" }}
                  margin={{ xs: "4% 0%", sm: "2% 0%" }}
                  data-aos={"fade-down"}
                >
                  <Box width={"30%"}>{icon}</Box>
                  <Box width={{ xs: "100%", sm: "70%" }}>
                    <Typography
                      variant={"h5"}
                      fontWeight={700}
                      paddingTop={{ xs: "2%", sm: "6%" }}
                    >
                      {title}
                    </Typography>
                    <Typography
                      variant={"body1"}
                      paddingTop={"3%"}
                      color={"#4f4f4f"}
                    >
                      {subtitle}
                    </Typography>
                  </Box>
                </Box>
                <Grid item xs={12} marginTop={{ xs: "0%", sm: "4%" }}>
                  <Divider color={"#fff"} />
                </Grid>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Framework;
